import React from 'react';
import Icon from 'Components/Icon';
import PropTypes from 'prop-types';
import BetSlipHorse from '../BetSlipHorse';

const BetSlipLeg = ({ leg, legData, index, onHorseDelete, raceNumber, betSlipBoxTitle }) => {
  if (!leg || !leg.length || (onHorseDelete && !legData || raceNumber < 0)) return null;
  return (
    <>
      <div className="game-row" key={ index }>
        <div className='game-row__leg-info'>
          <Icon className="game-row__horse-icon" iconName="svgBetslipHorse" />
          <div className="game-row__leg-no">  { betSlipBoxTitle.replace('%@', raceNumber + 1) } <span className="game-row__run-info">{ `(${legData?.legNo} .Koşu - ${legData?.startTime})` }</span>
          </div>
        </div>
      </div>
    { leg?.map(horse => <BetSlipHorse horse={ horse } key={ horse.uniqId } onHorseDelete={ onHorseDelete } />) }
    </>
  );
};
BetSlipLeg.propTypes = {
  leg: PropTypes.object,
  legData: PropTypes.object,
  index: PropTypes.number,
  raceNumber: PropTypes.number,
  onHorseDelete: PropTypes.func,
  betSlipBoxTitle: PropTypes.string
};
    
  
export default BetSlipLeg;
